import { render, staticRenderFns } from "./alarmList.vue?vue&type=template&id=2ac2c13f&scoped=true&"
import script from "./alarmList.vue?vue&type=script&lang=js&"
export * from "./alarmList.vue?vue&type=script&lang=js&"
import style0 from "./alarmList.vue?vue&type=style&index=0&id=2ac2c13f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac2c13f",
  null
  
)

export default component.exports